import { useT } from '~/i18n/LocaleContext';
import { useEpochProgress } from '~/pages/epochs/utils';

export function CpcEpochProgressBar({ className = '' }: { className?: string }) {
	const t = useT();
	const { epoch, progress, label } = useEpochProgress(t('stake.remaining'));

	if (progress == null || epoch == null) {
		return (
			<div className={`rounded-xl border border-[#1E293B] bg-[#0F172A]/60 p-4 ${className}`}>
				<div className="text-sm text-[#aeb9d0]">{t('stake.epochLoading')}</div>
			</div>
		);
	}

	const pct = Math.round(progress);

	return (
		<div className={`rounded-xl border border-[#1E293B] bg-[#0F172A]/60 p-4 ${className}`}>
			<div className="flex items-center justify-between text-sm mb-2">
				<span className="text-[#aeb9d0]">
					{t('stake.epochProgressOf').replace('{epoch}', String(epoch))}
				</span>
				<span className="text-[#38BDF8] font-medium tabular-nums">{label ?? `${pct}%`}</span>
			</div>
			<div className="h-2 rounded-full bg-[#1E293B] overflow-hidden">
				<div
					className="h-full rounded-full bg-gradient-to-r from-[#38BDF8] to-emerald-400 transition-all duration-500"
					style={{ width: `${pct}%` }}
				/>
			</div>
			<div className="mt-1.5 text-right text-xs text-[#94a3b8] tabular-nums">{pct}%</div>
		</div>
	);
}
